import React from 'react';
import { Card } from '@material-ui/core';
import Button from 'components/Button';
import { Captions, SmallSectionHeader, ShortBody } from 'components/Typography';
import styled from 'styled-components';

export const List = styled.ul`
  margin: 0px;
  padding-left: 15px;
  && {
    > li::marker {
      color: #f9ac19;
      font-weight: bold;
      display: inline-block;
      width: 1em;
      margin-left: -1em;
    }
  }
`;

export const ContentWrapper = styled(({ reverse, ...otherProps }) => (
  <Card {...otherProps} />
))`
  padding: ${(props) => (props.reverse ? '30px 16px' : '10px 16px')} !important;
  padding: 10px 16px;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);
`;

export const StyledButton = styled(Button)`
  && {
    width: auto;
    color: #172c51;
    font-size: 11px !important;
    &:hover {
      color: #285bc7 !important;
    }
  }
`;

export const StyledCaptions = styled(Captions)`
  && {
    margin-bottom: 3px;
  }
`;

export const StyledTitle = styled(SmallSectionHeader)`
  && {
    margin-bottom: 16px;
  }
`;

export const WrappedLineShortBody = styled(ShortBody)`
  && {
    white-space: pre-line;
    margin-bottom: 8px;
  }
`;
